import NucleusBaseContainer from '../Base';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

export const UINucleusContainer = (props: Props) => {
  const containerStyle: React.CSSProperties = {
    width: '100%',
    // The page layout (Main.tsx) renders a fixed 55px TopBar (53px + 2px border)
    // above the <Outlet/>. A plain height:100% makes this scroll container extend
    // 55px past the viewport, where the parent's overflow:hidden clips the last row
    // into an unreachable dead zone. Subtracting the TopBar height keeps the scroll
    // area within the visible viewport so the scrollbar reaches the true bottom.
    // Consumers not under the TopBar (e.g. modals) can override via the style prop.
    height: 'calc(100% - 55px)',
    border: '1px none orange',
    display: 'inline-block',
    paddingLeft: '30px',
    paddingRight: '10px',
    minHeight: '88% !important',
    marginBottom: '10px !important',
    position: 'relative',
    overflow: 'auto',
    ...props.style,
  };

  return <NucleusBaseContainer style={containerStyle} {...props} />;
};
